/**
 * KAN-833, KAN-877: "Позвонить" в шапке карточки клиента кабинета. Один
 * клиент, поэтому адресаты звонка грузятся сразу (кнопка на ЛПР с его номером).
 */
import { ManagerCallButton } from '@/components/clients/ManagerCallButton';

interface ClientHeaderCallProps {
  clientId: string;
  phone?: string | null;
}

export function ClientHeaderCall({ clientId, phone }: ClientHeaderCallProps) {
  if (!phone) return null;
  return <ManagerCallButton clientId={clientId} phone={phone} testId="client-call-button" targetMode="eager" />;
}
